import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Snackbar,
  Alert,
  styled,
  Paper,
  Card,
  CardContent,
  Stack,
  IconButton,
  Chip,
  Grid,
  Divider,
  useTheme,
  Tooltip,
  Avatar,
  InputAdornment,
} from "@mui/material";
import {
  SwapVert as SwapVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  FileDownload as FileDownloadIcon,
  Add as AddIcon,
  FilterList as FilterListIcon,
  Assignment as AssignmentIcon,
  DateRange as DateRangeIcon,
  Euro as EuroIcon,
  AccessTime as AccessTimeIcon,
  FilterAlt as FilterAltIcon,
  Search as SearchIcon,
  Person as PersonIcon,
  Code as CodeIcon,
} from "@mui/icons-material";
import axios from "axios";
import { MaterialReactTable } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { getToken, base_url } from "../../config/config";
import { tokens } from "../../theme";

// Styled components
const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 12,
  boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)",
  transition: "transform 0.3s, box-shadow 0.3s",
  overflow: "visible",
  "&:hover": {
    boxShadow: "0 8px 30px 0 rgba(0,0,0,0.1)",
    transform: "translateY(-5px)",
  },
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: 8,
  textTransform: "none",
  boxShadow: "none",
  fontWeight: 600,
  fontSize: 14,
  "&:hover": {
    boxShadow: "0 4px 10px 0 rgba(0,0,0,0.1)",
  },
}));

const FilterSection = styled(Box)(({ theme }) => ({
  padding: 16,
  borderRadius: 12,
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.background.paper : "#fff",
  boxShadow: "0 2px 16px 0 rgba(0,0,0,0.05)",
  marginBottom: 24,
}));

const ReportCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: 12,
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.background.paper : "#fff",
  boxShadow: "0 2px 8px 0 rgba(0,0,0,0.05)",
  transition: "transform 0.2s",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 6px 12px 0 rgba(0,0,0,0.1)",
  },
}));

const Team2 = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Get today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split("T")[0];

  // State declarations
  const [apiData, setApiData] = useState([]);
  const [refreshId, setRefreshId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [filterUser, setFilterUser] = useState("");
  const [filterANR, setFilterANR] = useState("");
  const [overtimeFilter, setOvertimeFilter] = useState("");
  const [editData, setEditData] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [isFiltersVisible, setIsFiltersVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  // Stats state
  const [stats, setStats] = useState({
    totalProjects: 0,
    totalHours: 0,
    totalEmployees: 0,
    averageHoursPerProject: 0,
    uniqueEmployeesInFilteredData: 0,
  });

  const [newData, setNewData] = useState({
    user: "",
    ANR: "",
    description: "",
    date: "",
    StartTime: "",
    EndTime: "",
    Arbeiten: "",
    Menge: "",
    isOverTime: false,
  });

  // State for selected date for daily report
  const [selectedDate, setSelectedDate] = useState("");

  // State for user feedback via Snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // State to manage submission status
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Hourly rate state variable
  const [hourlyRate, setHourlyRate] = useState(75);

  // Total work time in minutes (8 hours 15 minutes)
  const TOTAL_WORK_TIME_MINUTES = 8 * 60 + 15;

  // Function to close the Snackbar
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Dropdown component for selecting employees
  const EmployeeSelect = ({ value, onChange }) => (
    <FormControl fullWidth sx={{ mb: 2 }}>
      <InputLabel>Mitarbeiter</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label="Mitarbeiter"
        sx={{ borderRadius: 2 }}
      >
        {employees.map((employee) => (
          <MenuItem key={employee.name} value={employee.name}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Avatar
                sx={{
                  width: 24,
                  height: 24,
                  bgcolor: colors.blueAccent[500],
                  fontSize: "0.8rem",
                }}
              >
                {employee.name.charAt(0).toUpperCase()}
              </Avatar>
              <Typography>{employee.name}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  // Fetch employees data
  const fetchEmployees = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${base_url}/v1/getAllEmployees`);

      if (response.status === 200) {
        setEmployees(response.data);
        console.log("asd", response.data);
        setStats((prev) => ({ ...prev, totalEmployees: response.data.length }));
      } else {
        console.error("Error fetching employees data:", response.data.message);
        setSnackbar({
          open: true,
          message: `Fehler beim Abrufen der Mitarbeiterdaten: ${response.data.message}`,
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error fetching employees data:", error.message);
      setSnackbar({
        open: true,
        message: `Fehler beim Abrufen der Mitarbeiterdaten: ${error.message}`,
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const handleClearFilters = () => {
    setStartDate("");
    setEndDate("");
    setFilterUser("");
    setFilterANR("");
    setOvertimeFilter("");
    setSelectedDate("");
    setHourlyRate(75); // Reset to default hourly rate
  };
  useEffect(() => {
    fetchEmployees();
  }, []);

  // Fetch API data
  useEffect(() => {
    setIsLoading(true);
    axios
      .get(`${base_url}/v1/getAllUserProjects`)
      .then((response) => {
        if (response.data.status === 1) {
          setApiData(response.data.data);

          // Only update total available projects in the database
          // Other stats will be updated based on filtered data
          setStats((prev) => ({
            ...prev,
            totalProjects: response.data.data.length,
          }));
        } else {
          console.error("Error fetching API data:", response.data.message);
          setSnackbar({
            open: true,
            message: `Fehler beim Abrufen der Daten: ${response.data.message}`,
            severity: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching API data:", error);
        setSnackbar({
          open: true,
          message: `Fehler beim Abrufen der Daten: ${error.message}`,
          severity: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [refreshId]);

  // Helper function to calculate total time and percentage
  const calculateTotalTime = (startTime, endTime) => {
    if (!startTime || !endTime) return { totalTime: "Pending", percentage: 0 };

    const parseTime = (timeStr) => {
      const [hours = "0", minutes = "0", seconds = "0"] = timeStr.split(":");
      return new Date(
        1970,
        0,
        1,
        Number(hours),
        Number(minutes),
        Number(seconds)
      );
    };

    const startDate = parseTime(startTime);
    let endDate = parseTime(endTime);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime()))
      return { totalTime: "Pending", percentage: 0 };

    if (endDate < startDate) {
      endDate.setDate(endDate.getDate() + 1);
    }

    const diffMs = endDate - startDate;
    if (isNaN(diffMs) || diffMs <= 0)
      return { totalTime: "Pending", percentage: 0 };

    const breakfastStart = parseTime("08:45");
    const breakfastEnd = parseTime("09:00");
    const lunchStart = parseTime("11:45");
    const lunchEnd = parseTime("12:00");

    const adjustForBreak = (start, end, breakStart, breakEnd) => {
      if (end <= breakStart || start >= breakEnd) {
        return 0;
      }

      const overlapStart = new Date(Math.max(start, breakStart));
      const overlapEnd = new Date(Math.min(end, breakEnd));

      return overlapEnd - overlapStart;
    };

    let breakTimeMs = 0;
    breakTimeMs += adjustForBreak(
      startDate,
      endDate,
      breakfastStart,
      breakfastEnd
    );
    breakTimeMs += adjustForBreak(startDate, endDate, lunchStart, lunchEnd);

    const effectiveDiffMs = diffMs - breakTimeMs;
    if (isNaN(effectiveDiffMs) || effectiveDiffMs <= 0)
      return { totalTime: "Pending", percentage: 0 };

    const diffMins = Math.floor(effectiveDiffMs / 60000);
    const diffHrs = Math.floor(diffMins / 60);
    const remainingMins = diffMins % 60;

    const totalMinutesInDay = 8 * 60 + 15; // 8 hours and 15 minutes in total
    const percentage = (diffMins / totalMinutesInDay) * 100;

    return {
      totalTime: `${diffHrs}h ${remainingMins}m`,
      percentage: percentage.toFixed(2),
      minutes: diffMins,
    };
  };

  // Filter data based on date range, user, ANR, and overtime
  useEffect(() => {
    let totalMinutes = 0;
    const uniqueEmployees = new Set();
    const uniqueAnrs = new Set();

    const filtered = apiData
      .map((project) => {
        const { totalTime, percentage, minutes } = calculateTotalTime(
          project.StartTime,
          project.EndTime
        );

        return {
          ...project,
          TotalTime: totalTime,
          Percentage: `${percentage}%`,
          Minutes: minutes || 0,
        };
      })
      .filter((project) => {
        const projectDate = new Date(project.date);
        const start = startDate ? new Date(startDate) : null;
        const end = endDate ? new Date(endDate) : null;

        const matchesDateRange =
          (!start || projectDate >= start) && (!end || projectDate <= end);
        const matchesUser =
          !filterUser ||
          (project.user &&
            project.user.toLowerCase().includes(filterUser.toLowerCase()));

        // Exact match for ANR
        const matchesANR =
          !filterANR || (project.ANR && project.ANR.toString() === filterANR);

        const matchesOvertime =
          !overtimeFilter ||
          (overtimeFilter === "Ja" ? project.isOverTime : !project.isOverTime);

        return matchesDateRange && matchesUser && matchesANR && matchesOvertime;
      })
      .sort((a, b) => new Date(b.date) - new Date(a.date));

    // Calculate stats from filtered data
    filtered.forEach((project) => {
      // Count unique employees in filtered data
      if (project.user) {
        uniqueEmployees.add(project.user);
      }

      // Count unique ANRs
      if (project.ANR) {
        uniqueAnrs.add(project.ANR);
      }

      // Sum all minutes
      if (project.Minutes) {
        totalMinutes += project.Minutes;
      }
    });

    setFilteredData(filtered);

    // Update stats based on filtered data
    const totalHours = totalMinutes / 60;
    const avgHoursPerProject =
      filtered.length > 0 ? totalHours / filtered.length : 0;

    setStats((prev) => ({
      ...prev,
      totalProjects: filtered.length, // Update to show filtered count instead of total
      totalHours: totalHours.toFixed(2),
      averageHoursPerProject: avgHoursPerProject.toFixed(2),
      uniqueEmployeesInFilteredData: uniqueEmployees.size,
    }));
  }, [startDate, endDate, apiData, filterUser, filterANR, overtimeFilter]);

  // Define table columns with responsiveness
  const columns = useMemo(
    () => [
      {
        accessorKey: "user",
        header: "Mitarbeiter",
        minSize: 150,
        maxSize: 250,
        Cell: ({ row }) => (
          <Stack direction="row" alignItems="center" spacing={1}>
            <Avatar
              sx={{
                width: 30,
                height: 30,
                bgcolor: colors.blueAccent[500],
                fontSize: "0.8rem",
              }}
            >
              {row.original.user?.charAt(0).toUpperCase() || "?"}
            </Avatar>
            <Typography variant="body2">{row.original.user}</Typography>
          </Stack>
        ),
      },
      {
        accessorKey: "ANR",
        header: "ANR",
        minSize: 100,
        maxSize: 150,
        Cell: ({ row }) => (
          <Chip
            label={row.original.ANR}
            color="primary"
            variant="outlined"
            size="small"
            icon={<CodeIcon />}
            sx={{ fontWeight: 500 }}
          />
        ),
      },
      {
        accessorKey: "Percentage",
        header: "Prozent",
        minSize: 100,
        maxSize: 150,
        Cell: ({ row }) => (
          <Box
            sx={{
              bgcolor:
                parseFloat(row.original.Percentage) >= 100
                  ? colors.greenAccent[500] + "33"
                  : colors.grey[800] + "22",
              py: 0.5,
              px: 1.5,
              borderRadius: 5,
              display: "inline-block",
            }}
          >
            <Typography
              variant="body2"
              fontWeight={600}
              color={
                parseFloat(row.original.Percentage) >= 100
                  ? colors.greenAccent[500]
                  : colors.grey[800]
              }
            >
              {row.original.Percentage}
            </Typography>
          </Box>
        ),
      },
      {
        accessorKey: "Menge",
        header: "Menge",
        minSize: 80,
        maxSize: 120,
        Cell: ({ row }) => (
          <Chip
            label={row.original.Menge}
            size="small"
            sx={{ fontWeight: 500 }}
          />
        ),
      },
      {
        accessorKey: "description",
        header: "Beschreibung",
        minSize: 150,
        maxSize: 250,
        Cell: ({ row }) => (
          <Typography
            variant="body2"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {row.original.description}
          </Typography>
        ),
      },
      {
        accessorKey: "date",
        header: "Datum",
        minSize: 100,
        maxSize: 150,
        Cell: ({ row }) => (
          <Chip
            icon={<DateRangeIcon />}
            label={new Date(row.original.date).toLocaleDateString("de-DE")}
            variant="outlined"
            size="small"
            sx={{ fontWeight: 500 }}
          />
        ),
      },
      {
        accessorKey: "StartTime",
        header: "Startzeit",
        minSize: 100,
        maxSize: 150,
        Cell: ({ row }) => (
          <Typography variant="body2" fontFamily="monospace" fontWeight={500}>
            {row.original.StartTime}
          </Typography>
        ),
      },
      {
        accessorKey: "EndTime",
        header: "Endzeit",
        minSize: 100,
        maxSize: 150,
        Cell: ({ row }) => (
          <Typography variant="body2" fontFamily="monospace" fontWeight={500}>
            {row.original.EndTime}
          </Typography>
        ),
      },
      {
        accessorKey: "TotalTime",
        header: "Gesamtzeit",
        minSize: 100,
        maxSize: 150,
        Cell: ({ row }) => (
          <Typography
            variant="body2"
            fontWeight={600}
            fontFamily="monospace"
            sx={{
              color: colors.blueAccent[400],
            }}
          >
            {row.original.TotalTime}
          </Typography>
        ),
      },
      {
        accessorKey: "Arbeiten",
        header: "Arbeiten",
        minSize: 200,
        maxSize: 300,
        Cell: ({ row }) => (
          <Typography
            variant="body2"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {row.original.Arbeiten}
          </Typography>
        ),
      },
      {
        accessorKey: "isOverTime",
        header: "Überstunden",
        minSize: 100,
        maxSize: 150,
        Cell: ({ cell }) =>
          cell.getValue() ? (
            <Chip
              label="Ja"
              color="error"
              size="small"
              sx={{ fontWeight: 600 }}
            />
          ) : (
            <Chip
              label="Nein"
              variant="outlined"
              size="small"
              sx={{ fontWeight: 500 }}
            />
          ),
      },
      {
        accessorKey: "actions",
        header: "Aktionen",
        minSize: 150,
        maxSize: 200,
        Cell: ({ row }) => (
          <Stack direction="row" spacing={1}>
            <Tooltip title="Bearbeiten">
              <IconButton
                color="primary"
                onClick={() => handleEditOpen(row.original)}
                size="small"
                sx={{
                  bgcolor: colors.primary[400] + "22",
                  "&:hover": {
                    bgcolor: colors.primary[400] + "44",
                  },
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Löschen">
              <IconButton
                color="error"
                onClick={() => handleDelete(row.original._id)}
                size="small"
                sx={{
                  bgcolor: colors.redAccent[500] + "22",
                  "&:hover": {
                    bgcolor: colors.redAccent[500] + "44",
                  },
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        ),
      },
    ],
    [colors]
  );

  // Handle export to Excel
  const handleExport = () => {
    const visibleData = filteredData.map((row) => ({
      user: row.user,
      ANR: row.ANR,
      description: row.description,
      date: row.date,
      StartTime: row.StartTime,
      EndTime: row.EndTime,
      TotalTime: row.TotalTime,
      Arbeiten: row.Arbeiten,
      isOverTime: row.isOverTime ? "Ja" : "Nein",
    }));

    const worksheet = XLSX.utils.json_to_sheet(visibleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Filtered Projects");
    XLSX.writeFile(workbook, "filtered_projects.xlsx");

    setSnackbar({
      open: true,
      message: "Daten erfolgreich als Excel exportiert",
      severity: "success",
    });
  };

  // Handle export to PDF
  const handleExportPDF = () => {
    const doc = new jsPDF("landscape");
    doc.text("Gefilterte Projekte", 14, 16);

    const tableColumn = [
      "Mitarbeiter",
      "ANR",
      "Menge",
      "Beschreibung",
      "Datum",
      "Startzeit",
      "Endzeit",
      "Gesamtzeit",
      "Percentage",
      "Arbeiten",
      "Überstunden",
    ];

    const tableRows = filteredData.map((row) => [
      row.user,
      row.ANR,
      row.Menge,
      row.description,
      row.date,
      row.StartTime,
      row.EndTime,
      row.TotalTime,
      row.Percentage,
      row.Arbeiten,
      row.isOverTime ? "Ja" : "Nein",
    ]);

    // Calculate the total sum of all TotalTime in minutes
    let totalMinutes = 0;
    filteredData.forEach((row) => {
      if (row.TotalTime && row.TotalTime.includes("h")) {
        const [hours, minutes] = row.TotalTime.split("h ").map((time) =>
          parseInt(time, 10)
        );
        totalMinutes += hours * 60 + minutes;
      }
    });

    // Convert total minutes to hours and minutes format
    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    const totalTimeFormatted = `${totalHours}h ${remainingMinutes}m`;

    // Calculate the total cost using the hourlyRate state variable
    const totalCost = (totalMinutes / 60) * hourlyRate;

    // Add the rows to the PDF
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 20,
      styles: { fontSize: 10, cellPadding: 3 },
      theme: "striped",
      headStyles: { fillColor: [41, 128, 185] },
      bodyStyles: {
        fillColor: (row, data) => {
          return row.cells[10].raw === "Ja" ? [231, 76, 60] : [255, 255, 255];
        },
      },
    });

    let finalY = doc.lastAutoTable.finalY + 10;

    // Check if there is enough space to add the summary rows, else add a new page
    if (finalY + 20 > doc.internal.pageSize.height) {
      doc.addPage();
      finalY = 20; // Reset Y position for new page
    }
    doc.text(`Gesamtzeit: ${totalTimeFormatted}`, 14, finalY);
    doc.text(`Gesamtkosten: €${totalCost.toFixed(2)}`, 14, finalY + 10);

    doc.save("filtered_projects.pdf");

    setSnackbar({
      open: true,
      message: "Daten erfolgreich als PDF exportiert",
      severity: "success",
    });
  };

  // Handle custom export (Büttner Export)
  const handleCustomExport = () => {
    const formattedData = filteredData.map((row) => {
      const auftragNr = row.ANR ? row.ANR.split("-")[0] : ""; // Extract Auftrag-Nr (first part of ANR)

      let az = 0; // Initialize az
      if (
        row.TotalTime &&
        row.TotalTime.includes("h") &&
        row.TotalTime.includes("m")
      ) {
        // Safely split TotalTime if it exists in "Xh Ym" format
        const timeParts = row.TotalTime.split("h ");
        const hours = parseInt(timeParts[0]) || 0;
        const minutes = parseInt(timeParts[1]?.replace("m", "")) || 0;
        az = hours * 100 + (minutes * 100) / 60;
      }

      // Format az and laufzeit with commas instead of points
      const azFormatted = (az * 0.01).toFixed(2).replace(".", ",");
      const laufzeitFormatted = (az * 0.01).toFixed(2).replace(".", ",");

      // Return formatted row data
      return {
        datum: row.date || "",
        "Auftrag-Nr.": auftragNr || "",
        "anr-un": "",
        jahr: "",
        az: azFormatted,
        menge: row.Menge || "",
        artikel: row.description || "",
        name: row.user || "",
        Kunde: "",
        laufzeit: laufzeitFormatted,
        kosten: "",
        "Zulage 10%": "",
        "Zulage 25%": "",
        "Zulage 50%": "",
        Spalte1: row.ANR || "",
        Spalte2: "",
      };
    });

    // Create Excel worksheet from formatted data
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ExportedData");
    XLSX.writeFile(workbook, "custom_export.xlsx");

    setSnackbar({
      open: true,
      message: "Büttner-Export erfolgreich erstellt",
      severity: "success",
    });
  };

  // Export daily report as PDF
  const exportDailyReport = () => {
    // Check if a date is selected
    if (!selectedDate) {
      setSnackbar({
        open: true,
        message: "Bitte wählen Sie ein Datum aus.",
        severity: "warning",
      });
      return;
    }

    // Filter data for the selected date
    const filteredDataForDate = filteredData.filter((row) => {
      if (!row.date) return false;

      // Convert both to YYYY-MM-DD format for comparison
      const rowDate = new Date(row.date).toISOString().split("T")[0];
      return rowDate === selectedDate;
    });

    if (filteredDataForDate.length === 0) {
      setSnackbar({
        open: true,
        message: `Keine Daten für das Datum ${selectedDate} gefunden. Bitte überprüfen Sie, ob Projekteinträge für dieses Datum existieren.`,
        severity: "info",
      });
      return;
    }

    // Show count of found entries
    setSnackbar({
      open: true,
      message: `${filteredDataForDate.length} Einträge für ${selectedDate} gefunden. Bericht wird erstellt...`,
      severity: "success",
    });

    // Export the filtered data to PDF
    handleExportSingleDayPDF(filteredDataForDate);
  };

  const handleExportSingleDayPDF = (filteredData) => {
    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 14;
    let currentY = 16;

    // Title
    doc.setFontSize(16);
    doc.text(`Tagesbericht für ${selectedDate}`, pageWidth / 2, currentY, {
      align: "center",
    });
    currentY += 10;

    const tableColumn = [
      "ANR",
      "Menge",
      "Beschreibung",
      "Startzeit",
      "Endzeit",
      "Gesamtzeit",
      "Prozent (%)",
      "Arbeiten",
      "Überstunden",
    ];

    // Group data by employee
    const employeeDataMap = {};
    filteredData.forEach((row) => {
      if (!employeeDataMap[row.user]) {
        employeeDataMap[row.user] = [];
      }
      employeeDataMap[row.user].push(row);
    });

    // Iterate over each employee and add their section
    Object.keys(employeeDataMap).forEach((employee, index) => {
      // Calculate total minutes worked
      let totalMinutes = 0;
      employeeDataMap[employee].forEach((row) => {
        if (row.TotalTime && row.TotalTime.includes("h")) {
          const [hours, minutes] = row.TotalTime.split("h ").map((time) =>
            parseInt(time, 10)
          );
          totalMinutes += hours * 60 + minutes;
        }
      });

      const totalHours = Math.floor(totalMinutes / 60);
      const remainingMinutes = totalMinutes % 60;
      const totalTimeFormatted = `${totalHours}h ${remainingMinutes}m`;

      // Calculate total percentage of workday
      const totalPercentage =
        ((totalMinutes / TOTAL_WORK_TIME_MINUTES) * 100).toFixed(2) + "%";

      // Employee Heading
      doc.setFontSize(14);
      doc.setTextColor(41, 128, 185); // Optional: Change text color for headings
      doc.text(`Mitarbeiter: ${employee}`, margin, currentY);
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Reset text color to black
      doc.text(
        `Gesamtarbeitszeit: ${totalTimeFormatted}`,
        margin,
        currentY + 6
      );
      doc.text(
        `Gesamtprozent des Arbeitstages: ${totalPercentage}`,
        margin,
        currentY + 12
      );
      currentY += 18;

      // Sort employee data by StartTime
      const sortedEmployeeData = employeeDataMap[employee].sort((a, b) => {
        const timeA = a.StartTime.split(":").map(Number);
        const timeB = b.StartTime.split(":").map(Number);
        return timeA[0] - timeB[0] || timeA[1] - timeB[1];
      });

      // Employee Table
      const tableRows = sortedEmployeeData.map((row) => [
        row.ANR,
        row.Menge,
        row.description,
        row.StartTime,
        row.EndTime,
        row.TotalTime,
        row.Percentage,
        row.Arbeiten,
        row.isOverTime ? "Ja" : "Nein",
      ]);

      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: currentY,
        margin: { left: margin, right: margin },
        styles: { fontSize: 10, cellPadding: 3 },
        theme: "striped",
        headStyles: { fillColor: [41, 128, 185] }, // Optional: Header background color
        bodyStyles: {
          // Highlight rows with overtime
          fillColor: (row, data) => {
            return row.cells[8].raw === "Ja" ? [231, 76, 60] : [255, 255, 255];
          },
        },
        didDrawPage: (data) => {
          currentY = data.cursor.y + 10;
        },
        // Add spacing after table
        afterPageContent: () => {
          currentY += 5; // Additional space if a new page is added
        },
      });

      // Update currentY position after table
      currentY = doc.lastAutoTable.finalY + 10; // Increased from +5 to +10 for more space

      // Add multiple separator lines for better separation
      const numberOfLines = 2; // Number of separator lines
      const lineSpacing = 2; // Space between each separator line

      for (let i = 0; i < numberOfLines; i++) {
        if (currentY > pageHeight - margin) {
          doc.addPage();
          currentY = margin;
        }
        doc.setDrawColor(41, 128, 185); // Matching the header color
        doc.setLineWidth(0.5);
        doc.line(margin, currentY, pageWidth - margin, currentY); // Draw a horizontal line
        currentY += lineSpacing; // Space after each line
      }

      currentY += 5; // Additional space after the separator lines

      // Check if adding a new employee exceeds the page height
      if (currentY > pageHeight - margin) {
        doc.addPage();
        currentY = margin;
      }
    });

    doc.save(`daily_report_${selectedDate}.pdf`);

    setSnackbar({
      open: true,
      message: "Tagesbericht erfolgreich erstellt",
      severity: "success",
    });
  };

  // Handle opening of edit modal
  const handleEditOpen = (rowData) => {
    setEditData(rowData);
    setIsEditOpen(true);
  };

  // Handle closing of edit modal
  const handleEditClose = () => {
    setIsEditOpen(false);
  };

  // Handle saving of edited data
  const handleEditSave = async () => {
    try {
      const token = getToken();
      setIsSubmitting(true);
      const response = await axios.post(
        `${base_url}/v1/updateProjectbyId`,
        editData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (
        response.data &&
        (response.data.status === 1 || response.data.success)
      ) {
        setApiData((prevData) =>
          prevData.map((project) =>
            project._id === editData._id ? editData : project
          )
        );
        setIsEditOpen(false);
        setSnackbar({
          open: true,
          message: "Projekt erfolgreich aktualisiert!",
          severity: "success",
        });
        setRefreshId(Date.now()); // Trigger data refresh
      } else {
        setSnackbar({
          open: true,
          message: `Fehler beim Aktualisieren: ${response.data.message}`,
          severity: "error",
        });
        console.error("Error updating project:", response.data.message);
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: `Fehler beim Aktualisieren: ${error.message}`,
        severity: "error",
      });
      console.error("Error updating project:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle opening of add modal
  const handleAddOpen = () => {
    setIsAddOpen(true);
  };

  // Handle closing of add modal
  const handleAddClose = () => {
    setIsAddOpen(false);
  };

  // Handle saving of new data
  const handleAddSave = async () => {
    // Basic form validation
    if (
      !newData.user ||
      !newData.ANR ||
      !newData.description ||
      !newData.date ||
      !newData.StartTime ||
      !newData.EndTime ||
      !newData.Menge ||
      !newData.Arbeiten
    ) {
      setSnackbar({
        open: true,
        message: "Bitte füllen Sie alle erforderlichen Felder aus.",
        severity: "warning",
      });
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${base_url}/v1/createUserProjectDashboard`,
        newData
      );
      if (response.data.status === 1) {
        setApiData([...apiData, response.data.data]);
        setIsAddOpen(false);
        setSnackbar({
          open: true,
          message: "Neues Projekt erfolgreich hinzugefügt!",
          severity: "success",
        });
        setRefreshId(Date.now()); // Trigger data refresh
        // Reset newData
        setNewData({
          user: "",
          ANR: "",
          description: "",
          date: "",
          StartTime: "",
          EndTime: "",
          Arbeiten: "",
          Menge: "",
          isOverTime: false,
        });
      } else {
        setSnackbar({
          open: true,
          message: `Fehler beim Hinzufügen: ${response.data.message}`,
          severity: "error",
        });
        console.error("Error adding project:", response.data.message);
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: `Fehler beim Hinzufügen: ${error.message}`,
        severity: "error",
      });
      console.error("Error adding project:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle deletion of a project
  const handleDelete = async (id) => {
    if (
      !window.confirm(
        "Sind Sie sicher, dass Sie dieses Projekt löschen möchten?"
      )
    ) {
      return;
    }

    try {
      const token = getToken();
      setIsLoading(true);
      const response = await axios.delete(
        `${base_url}/v1/deleteUserProject/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status === 1) {
        setApiData((prevData) =>
          prevData.filter((project) => project._id !== id)
        );
        setSnackbar({
          open: true,
          message: "Projekt erfolgreich gelöscht!",
          severity: "success",
        });
        setRefreshId(Date.now()); // Trigger data refresh
      } else {
        setSnackbar({
          open: true,
          message: `Fehler beim Löschen: ${response.data.message}`,
          severity: "error",
        });
        console.error("Error deleting project:", response.data.message);
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: `Fehler beim Löschen: ${error.message}`,
        severity: "error",
      });
      console.error("Error deleting project:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          variant="h2"
          fontWeight="bold"
          color={colors.grey[100]}
          sx={{ mb: 2 }}
        >
          Teamverwaltung
        </Typography>
      </Box>

      {/* Stats Dashboard */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StyledCard>
            <CardContent>
              <Stack spacing={2}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    color={colors.greenAccent[500]}
                  >
                    Projekte
                  </Typography>
                  <Avatar sx={{ bgcolor: colors.greenAccent[500] }}>
                    <AssignmentIcon />
                  </Avatar>
                </Box>
                <Typography variant="h3" fontWeight="bold">
                  {stats.totalProjects}
                </Typography>
                <Typography variant="body2" color={colors.grey[400]}>
                  {startDate ||
                  endDate ||
                  filterUser ||
                  filterANR ||
                  overtimeFilter
                    ? "Gefilterte Projekte"
                    : "Gesamtanzahl der Projekte"}
                </Typography>
                {startDate && endDate && startDate === endDate && (
                  <Chip
                    label={`Datum: ${new Date(startDate).toLocaleDateString(
                      "de-DE"
                    )}`}
                    size="small"
                    color="primary"
                    variant="outlined"
                    sx={{ alignSelf: "flex-start" }}
                  />
                )}
              </Stack>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StyledCard>
            <CardContent>
              <Stack spacing={2}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    color={colors.blueAccent[500]}
                  >
                    Stunden
                  </Typography>
                  <Avatar sx={{ bgcolor: colors.blueAccent[500] }}>
                    <AccessTimeIcon />
                  </Avatar>
                </Box>
                <Typography variant="h3" fontWeight="bold">
                  {stats.totalHours}
                </Typography>
                <Typography variant="body2" color={colors.grey[400]}>
                  {startDate ||
                  endDate ||
                  filterUser ||
                  filterANR ||
                  overtimeFilter
                    ? "Arbeitsstunden (gefiltert)"
                    : "Gesamtarbeitsstunden"}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <Tooltip title="Basierend auf den aktuellen Filtern">
                    <Chip
                      label={`€${(
                        parseFloat(stats.totalHours) * hourlyRate
                      ).toFixed(2)}`}
                      size="small"
                      color="default"
                      variant="outlined"
                      icon={<EuroIcon fontSize="small" />}
                      sx={{ alignSelf: "flex-start" }}
                    />
                  </Tooltip>
                </Box>
              </Stack>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StyledCard>
            <CardContent>
              <Stack spacing={2}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    color={colors.redAccent[500]}
                  >
                    Mitarbeiter
                  </Typography>
                  <Avatar sx={{ bgcolor: colors.redAccent[500] }}>
                    <PersonIcon />
                  </Avatar>
                </Box>
                <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
                  <Typography variant="h3" fontWeight="bold">
                    {stats.uniqueEmployeesInFilteredData}
                  </Typography>
                  <Typography variant="body2" color={colors.grey[400]}>
                    / {stats.totalEmployees}
                  </Typography>
                </Box>
                <Typography variant="body2" color={colors.grey[400]}>
                  {startDate ||
                  endDate ||
                  filterUser ||
                  filterANR ||
                  overtimeFilter
                    ? "Aktive Mitarbeiter / Gesamt"
                    : "Anzahl der Mitarbeiter"}
                </Typography>
                {filterUser && (
                  <Chip
                    label={`Filter: ${filterUser}`}
                    size="small"
                    color="error"
                    variant="outlined"
                    sx={{ alignSelf: "flex-start" }}
                  />
                )}
              </Stack>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <StyledCard>
            <CardContent>
              <Stack spacing={2}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    color={colors.primary[500]}
                  >
                    Durchschnitt
                  </Typography>
                  <Avatar sx={{ bgcolor: colors.primary[500] }}>
                    <AccessTimeIcon />
                  </Avatar>
                </Box>
                <Typography variant="h3" fontWeight="bold">
                  {stats.averageHoursPerProject}h
                </Typography>
                <Typography variant="body2" color={colors.grey[400]}>
                  {startDate ||
                  endDate ||
                  filterUser ||
                  filterANR ||
                  overtimeFilter
                    ? "Ø Stunden pro Projekt (gefiltert)"
                    : "Durchschnittliche Stunden pro Projekt"}
                </Typography>
                {filterANR && (
                  <Chip
                    label={`ANR: ${filterANR}`}
                    size="small"
                    color="primary"
                    variant="outlined"
                    sx={{ alignSelf: "flex-start" }}
                  />
                )}
              </Stack>
            </CardContent>
          </StyledCard>
        </Grid>
      </Grid>

      {/* Filter Toggle Button */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h4" color={colors.grey[200]} fontWeight="600">
          Projektübersicht
        </Typography>

        <Box display="flex" gap={2}>
          {/* Reset Filters Button - Only show when filters are applied */}
          {/* Clear Filters Button - Only show when filters are active */}
          {(startDate !== today ||
            endDate !== today ||
            filterUser ||
            filterANR ||
            overtimeFilter ||
            selectedDate ||
            hourlyRate !== 75) && (
            <ActionButton
              startIcon={<FilterAltIcon />}
              onClick={handleClearFilters}
              variant="outlined"
              color="secondary"
              size="small"
            >
              Filter zurücksetzen
            </ActionButton>
          )}

          <ActionButton
            startIcon={<FilterListIcon />}
            onClick={() => setIsFiltersVisible(!isFiltersVisible)}
            variant={isFiltersVisible ? "contained" : "outlined"}
            color="primary"
            size="small"
          >
            {isFiltersVisible ? "Filter ausblenden" : "Filter anzeigen"}
          </ActionButton>
        </Box>
      </Box>

      {/* Filters Section */}
      {isFiltersVisible && (
        <FilterSection>
          <Grid container spacing={2} alignItems="center">
            {/* Date Range Filters */}
            <Grid item xs={12} md={3}>
              <TextField
                label="Startdatum"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{
                  mb: { xs: 2, md: 0 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <DateRangeIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                label="Enddatum"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{
                  mb: { xs: 2, md: 0 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <DateRangeIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* User & ANR Filters */}
            <Grid item xs={12} md={3}>
              <TextField
                label="Filter Mitarbeiter"
                value={filterUser}
                onChange={(e) => setFilterUser(e.target.value)}
                fullWidth
                sx={{
                  mb: { xs: 2, md: 0 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                label="Filter ANR"
                value={filterANR}
                onChange={(e) => setFilterANR(e.target.value.trim())}
                placeholder="Geben Sie die genaue ANR ein"
                fullWidth
                sx={{
                  mb: { xs: 2, md: 0 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CodeIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Hourly Rate Input */}
            <Grid item xs={12} md={4}>
              <TextField
                label="Stundensatz (€)"
                type="number"
                value={hourlyRate}
                onChange={(e) => setHourlyRate(Number(e.target.value))}
                InputProps={{
                  inputProps: { min: 0 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <EuroIcon />
                    </InputAdornment>
                  ),
                }}
                fullWidth
                sx={{
                  mb: { xs: 2, md: 0 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              />
            </Grid>

            {/* Overtime Filter */}
            <Grid item xs={12} md={4}>
              <Box>
                <Typography sx={{ mb: 1 }}>Überstunden</Typography>
                <ToggleButtonGroup
                  value={overtimeFilter}
                  exclusive
                  onChange={(e, newFilter) => setOvertimeFilter(newFilter)}
                  aria-label="Überstunden Filter"
                  sx={{
                    "& .MuiToggleButton-root": {
                      borderRadius: 2,
                      px: 3,
                      py: 1,
                    },
                  }}
                >
                  <ToggleButton value="Ja" aria-label="Ja">
                    Ja
                  </ToggleButton>
                  <ToggleButton value="Nein" aria-label="Nein">
                    Nein
                  </ToggleButton>
                  <ToggleButton value="" aria-label="Alle">
                    Alle
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </Grid>

            {/* Add New Button */}
            <Grid
              item
              xs={12}
              md={4}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <ActionButton
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleAddOpen}
                sx={{ height: 50 }}
              >
                Neues Projekt hinzufügen
              </ActionButton>
            </Grid>
          </Grid>
        </FilterSection>
      )}

      {/* Export Cards Grid */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <ReportCard>
            <Stack spacing={2}>
              <Typography variant="h5" fontWeight="500">
                Excel Export
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Exportieren Sie alle gefilterten Daten nach Excel
              </Typography>
              <ActionButton
                variant="outlined"
                startIcon={<FileDownloadIcon />}
                onClick={handleExport}
                fullWidth
              >
                Excel Export
              </ActionButton>
            </Stack>
          </ReportCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <ReportCard>
            <Stack spacing={2}>
              <Typography variant="h5" fontWeight="500">
                PDF Export
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Exportieren Sie gefilterte Daten in PDF-Format
              </Typography>
              <ActionButton
                variant="outlined"
                startIcon={<FileDownloadIcon />}
                onClick={handleExportPDF}
                fullWidth
              >
                PDF Export
              </ActionButton>
            </Stack>
          </ReportCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <ReportCard>
            <Stack spacing={2}>
              <Typography variant="h5" fontWeight="500">
                Büttner Export
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Spezieller Export im Büttner-Format
              </Typography>
              <ActionButton
                variant="outlined"
                startIcon={<FileDownloadIcon />}
                onClick={handleCustomExport}
                fullWidth
              >
                Büttner Export
              </ActionButton>
            </Stack>
          </ReportCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <ReportCard>
            <Stack spacing={2}>
              <Typography variant="h5" fontWeight="500">
                Tagesbericht
              </Typography>
              <TextField
                label="Datum auswählen"
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                fullWidth
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                  },
                }}
              />
              <ActionButton
                variant="outlined"
                startIcon={<DateRangeIcon />}
                onClick={exportDailyReport}
                fullWidth
                disabled={!selectedDate}
              >
                Tagesbericht
              </ActionButton>
            </Stack>
          </ReportCard>
        </Grid>
      </Grid>

      {/* Data Table */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          overflow: "hidden",
          boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)",
        }}
      >
        {filteredData.length > 0 ? (
          <MaterialReactTable
            columns={columns}
            data={filteredData}
            state={{ isLoading }}
            enableFullScreenToggle={false}
            enableColumnResizing
            initialState={{
              density: "compact",
              pagination: { pageSize: 10 },
              sorting: [
                {
                  id: "date",
                  desc: true,
                },
              ],
            }}
            muiTableContainerProps={{
              sx: { maxHeight: "70vh" },
            }}
            muiTableBodyCellProps={{
              sx: {
                whiteSpace: "normal",
                wordWrap: "break-word",
                p: 1.5,
              },
            }}
            muiTableHeadCellProps={{
              sx: {
                whiteSpace: "normal",
                wordWrap: "break-word",
                fontWeight: "bold",
              },
            }}
            muiTablePaperProps={{
              elevation: 0,
              sx: {
                borderRadius: 0,
              },
            }}
            enableTopToolbar={true}
            muiTopToolbarProps={{
              sx: {
                backgroundColor:
                  theme.palette.mode === "dark"
                    ? colors.primary[500] + "22"
                    : colors.primary[500] + "08",
              },
            }}
            positionToolbarAlertBanner="bottom"
            renderTopToolbarCustomActions={({ table }) => (
              <Box sx={{ display: "flex", gap: 1, p: 1 }}>
                <Chip
                  label={`${filteredData.length} Projekt(e) gefunden`}
                  color="primary"
                  sx={{ fontWeight: 500 }}
                />
              </Box>
            )}
          />
        ) : (
          <Box
            sx={{
              p: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "200px",
            }}
          >
            <FilterAltIcon
              sx={{
                fontSize: 60,
                color: colors.grey[500],
                mb: 2,
                opacity: 0.5,
              }}
            />
            <Typography variant="h5" color={colors.grey[500]} align="center">
              Keine Projekte entsprechen den aktuellen Filtern.
            </Typography>
            <Typography
              variant="body2"
              color={colors.grey[400]}
              align="center"
              sx={{ mt: 1 }}
            >
              Versuchen Sie, Ihre Filterkriterien anzupassen.
            </Typography>
          </Box>
        )}
      </Paper>

      {/* Edit Modal */}
      <Dialog
        open={isEditOpen}
        onClose={handleEditClose}
        maxWidth="md"
        PaperProps={{
          sx: { borderRadius: 3 },
        }}
      >
        <DialogTitle
          sx={{ borderBottom: `1px solid ${colors.grey[300]}`, py: 2 }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <EditIcon color="primary" />
            <Typography variant="h5" fontWeight="bold">
              Projekt bearbeiten
            </Typography>
          </Stack>
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          {editData && (
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <EmployeeSelect
                    value={editData.user}
                    onChange={(e) =>
                      setEditData({ ...editData, user: e.target.value })
                    }
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="ANR"
                    fullWidth
                    value={editData.ANR}
                    onChange={(e) =>
                      setEditData({ ...editData, ANR: e.target.value })
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CodeIcon />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    label="Menge"
                    type="number"
                    fullWidth
                    value={editData.Menge}
                    onChange={(e) =>
                      setEditData({ ...editData, Menge: e.target.value })
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Beschreibung"
                    fullWidth
                    multiline
                    rows={2}
                    value={editData.description}
                    onChange={(e) =>
                      setEditData({ ...editData, description: e.target.value })
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Datum"
                    type="date"
                    fullWidth
                    value={editData.date}
                    onChange={(e) =>
                      setEditData({ ...editData, date: e.target.value })
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DateRangeIcon />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={5}>
                  <TextField
                    label="Startzeit"
                    type="time"
                    fullWidth
                    value={editData.StartTime}
                    onChange={(e) =>
                      setEditData({ ...editData, StartTime: e.target.value })
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={2}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <IconButton
                    color="primary"
                    onClick={() => {
                      const temp = editData.StartTime;
                      setEditData({
                        ...editData,
                        StartTime: editData.EndTime,
                        EndTime: temp,
                      });
                    }}
                    sx={{
                      bgcolor: colors.primary[500] + "22",
                      "&:hover": {
                        bgcolor: colors.primary[500] + "44",
                      },
                    }}
                  >
                    <SwapVertIcon />
                  </IconButton>
                </Grid>

                <Grid item xs={12} md={5}>
                  <TextField
                    label="Endzeit"
                    type="time"
                    fullWidth
                    value={editData.EndTime}
                    onChange={(e) =>
                      setEditData({ ...editData, EndTime: e.target.value })
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Arbeiten"
                    fullWidth
                    multiline
                    rows={3}
                    value={editData.Arbeiten}
                    onChange={(e) =>
                      setEditData({ ...editData, Arbeiten: e.target.value })
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Überstunden
                  </Typography>
                  <ToggleButtonGroup
                    value={editData.isOverTime ? "Ja" : "Nein"}
                    exclusive
                    onChange={(e, newFilter) =>
                      setEditData({
                        ...editData,
                        isOverTime: newFilter === "Ja",
                      })
                    }
                    aria-label="Überstunden"
                    fullWidth
                    sx={{
                      "& .MuiToggleButton-root": {
                        borderRadius: 2,
                        py: 1,
                      },
                    }}
                  >
                    <ToggleButton value="Ja" aria-label="Ja">
                      Ja
                    </ToggleButton>
                    <ToggleButton value="Nein" aria-label="Nein">
                      Nein
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Grid>
              </Grid>
            </form>
          )}
        </DialogContent>

        <DialogActions
          sx={{ px: 3, py: 2, borderTop: `1px solid ${colors.grey[300]}` }}
        >
          <Button
            onClick={handleEditClose}
            variant="outlined"
            color="secondary"
            sx={{ borderRadius: 2, px: 3 }}
          >
            Abbrechen
          </Button>
          <Button
            onClick={handleEditSave}
            variant="contained"
            color="primary"
            disabled={isSubmitting}
            sx={{ borderRadius: 2, px: 3 }}
          >
            {isSubmitting ? "Wird gespeichert..." : "Speichern"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Modal */}
      <Dialog
        open={isAddOpen}
        onClose={handleAddClose}
        maxWidth="md"
        PaperProps={{
          sx: { borderRadius: 3 },
        }}
      >
        <DialogTitle
          sx={{ borderBottom: `1px solid ${colors.grey[300]}`, py: 2 }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <AddIcon color="primary" />
            <Typography variant="h5" fontWeight="bold">
              Neues Projekt hinzufügen
            </Typography>
          </Stack>
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <EmployeeSelect
                  value={newData.user}
                  onChange={(e) =>
                    setNewData({ ...newData, user: e.target.value })
                  }
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="ANR"
                  fullWidth
                  value={newData.ANR}
                  onChange={(e) =>
                    setNewData({ ...newData, ANR: e.target.value })
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CodeIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="Menge"
                  type="number"
                  fullWidth
                  value={newData.Menge}
                  onChange={(e) =>
                    setNewData({ ...newData, Menge: e.target.value })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Beschreibung"
                  fullWidth
                  multiline
                  rows={2}
                  value={newData.description}
                  onChange={(e) =>
                    setNewData({ ...newData, description: e.target.value })
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Datum"
                  type="date"
                  fullWidth
                  value={newData.date}
                  onChange={(e) =>
                    setNewData({ ...newData, date: e.target.value })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <DateRangeIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="Startzeit"
                  type="time"
                  fullWidth
                  value={newData.StartTime}
                  onChange={(e) =>
                    setNewData({ ...newData, StartTime: e.target.value })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  label="Endzeit"
                  type="time"
                  fullWidth
                  value={newData.EndTime}
                  onChange={(e) =>
                    setNewData({ ...newData, EndTime: e.target.value })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Arbeiten"
                  fullWidth
                  multiline
                  rows={3}
                  value={newData.Arbeiten}
                  onChange={(e) =>
                    setNewData({ ...newData, Arbeiten: e.target.value })
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Überstunden
                </Typography>
                <ToggleButtonGroup
                  value={newData.isOverTime ? "Ja" : "Nein"}
                  exclusive
                  onChange={(e, newFilter) =>
                    setNewData({ ...newData, isOverTime: newFilter === "Ja" })
                  }
                  aria-label="Überstunden"
                  fullWidth
                  sx={{
                    "& .MuiToggleButton-root": {
                      borderRadius: 2,
                      py: 1,
                    },
                  }}
                >
                  <ToggleButton value="Ja" aria-label="Ja">
                    Ja
                  </ToggleButton>
                  <ToggleButton value="Nein" aria-label="Nein">
                    Nein
                  </ToggleButton>
                </ToggleButtonGroup>
              </Grid>
            </Grid>
          </form>
        </DialogContent>

        <DialogActions
          sx={{ px: 3, py: 2, borderTop: `1px solid ${colors.grey[300]}` }}
        >
          <Button
            onClick={handleAddClose}
            variant="outlined"
            color="secondary"
            sx={{ borderRadius: 2, px: 3 }}
          >
            Abbrechen
          </Button>
          <Button
            onClick={handleAddSave}
            variant="contained"
            color="primary"
            disabled={isSubmitting}
            sx={{ borderRadius: 2, px: 3 }}
          >
            {isSubmitting ? "Wird hinzugefügt..." : "Hinzufügen"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for user feedback */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%", borderRadius: 2 }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Team2;
